<template>
    <svg
      :width="getWidth"
      height="16"
      :viewBox="getViewBox"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <template v-if="this.step == 1">
        <circle cx="8" cy="8" r="7" stroke="#74979a" stroke-width="2" />
        <circle cx="8" cy="8" r="3.5" fill="#74979a" />
      </template>
  
      <template v-else>
        <circle cx="8" cy="8" r="8" fill="#74979a" />
        <path
          d="M11.3337 5.5L6.75033 10.0833L4.66699 8"
          stroke="#ffffff"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </template>
  
      <rect x="24" y="7" :width="getRectWidth" height="2" :fill="getRectFill" />
  
      <template v-if="this.step == 1">
        <circle
          :cx="getSecondCirclePostx"
          cy="8"
          r="7"
          stroke="#74979a"
          stroke-opacity="0.5"
          stroke-width="2"
        />
      </template>
      <template v-else>
        <circle
          :cx="getSecondCirclePostx"
          cy="8"
          r="7"
          stroke="#74979a"
          stroke-width="2"
        />
        <circle :cx="getSecondCirclePostx" cy="8" r="3.5" fill="#74979a" />
      </template>
  
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color: #74979a" />
          <stop offset="100%" style="stop-color: #d7dac9" />
        </linearGradient>
      </defs>
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      step: {
        type: Number,
        default: 1,
        validator: function (value) {
          return [1, 2].includes(value);
        },
      },
    },
    data() {
      return {
          width: 330,
          viewportSize: { width: 0, height: 0 },
      };
    },
    methods: {
      updateViewportSize() {
        this.viewportSize = {
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
      handleResize() {
  
          if(window.innerWidth < 768) {
              this.width = 180;
          } else {
              this.width = 330;
          }
  
          this.updateViewportSize();
      },
    },
    computed: {
      getWidth() {
        return this.width;
      },
      getSecondCirclePostx() {
        return this.width - 8;
      },
      getRectWidth() {
        return this.width - 48;
      },
      getViewBox() {
        return `0 0 ${this.width} 16`;
      },
      getRectFill() {
        return this.step == 1 ? "url(#gradient)" : "#74979a";
      },
    },
    mounted() {
      this.updateViewportSize();
  
      // Add event listener for window resize
      window.addEventListener("resize", this.handleResize);
  
      // Add a debounce function to avoid frequent updates during resize
      let timeout;
      window.addEventListener("resize", () => {
        clearTimeout(timeout);
        timeout = setTimeout(this.handleResize, 200); // Adjust the debounce time as needed
      });
    },
  
    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
    },
  };
  </script>
  